<template>  
<Modal v-model="model" title="系统公告" @on-cancel="cancel" sticky reset-drag-position footer-hide :mask="false" draggable :scrollable="true"
          width="1200">
    <div class="form-div main-margin-div">
        <div class="title" style="text-align: center;height: 100px">
            <h1>{{tittle}}</h1>
            <p><span style="margin-left: 3%;color: #999999;">发布人: {{author}}</span>
            <span style="margin-left: 3%;color: #999999;">时间: {{createTime}}</span></p>
        </div>
        <div :style="screenHeight">
            <div id="content" class="content_div">
            <!--      <div v-html="content"></div>-->
                <div class='parent' id='parent'></div>
            </div>
            <div >
                <div class="files" style="padding-top: 20px;" v-for="(item , index) in uploadList" :key="index" :id="item.id">
                    <a :href="item.fileUrl" target="_blank">{{item.showName}}</a>
                    <p style="padding-top: 10px;">{{item.description}}</p>
                </div>
            </div>
        </div>
    </div>
</Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import Vue from 'vue'

  export default {
    name: "SeeNotice",
    props: {
      notice: String,
      showSeeNotice:Boolean
    },
    mixins: [publicFunClass],
    data() {
      return {
        author:'',
        createTime:'',
        model:false,
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        uploadList: [],
        fileUrl: '',
        downName: '',
        isCollect: '',
        isOpen: '',
        tittle: '',
        fileAddr: '',
        description: '',
        content: '',
        spinShow: true,
        selected: true,
        showMessage: false,
        screenHeight: {'height': '','overflow-x': 'auto'},
        remark: '',
        srcList: [],
      }
    },
    methods: {
      cancel: function () {
        this.$emit("closeNotice");
      },
      showBigPicture: function () {
        alert("123");
      },
      initSearch: function (notice) {
        // console.log(notice);
        this.tittle=notice.title;
        this.author=notice.employeeName;
        this.createTime=notice.createTime;

        if(notice.fileAddr != null && notice.fileAddr != ''){
            let fileAddrList=notice.fileAddr.split(',');
            let descrList=notice.descr.split(',');
            for (let i = 0; i < fileAddrList.length; i++) {
              let showName=fileAddrList[i].substring(fileAddrList[i].lastIndexOf('/')+1,fileAddrList[i].indexOf('('));
              let type=fileAddrList[i].substring(fileAddrList[i].indexOf('.'),fileAddrList[i].length);
              let param = {
                showName: showName+type,
                fileUrl: this.baseURL + "common/downloadFile.json?type=0&addr=" + fileAddrList[i],
                //fileUrl: 'http://10.1.20.23/mpccApi/' + "common/downloadFile.json?type=0&addr=" + fileAddrList[i],
                description: descrList[i],
              }
              this.uploadList.push(param);
            }
        }

        document.getElementById('parent').innerHTML="";
        if (notice.content !='' && notice.content !=null) {
          let newMsg = notice.content;
          let reg = new RegExp('<img', 'g')//g代表全部
          let content = newMsg.replace(reg, '<el-image');
          let count = 0;
          let index = content.indexOf("<el-image");
          while (index != -1) {
            count++;
            let newContent = content.substring(index, content.length);

            let indexOne = newContent.indexOf("src=\"");
            let indexTwo = newContent.indexOf("\"",indexOne+5);
            let paramUrl = newContent.substring(indexOne + 5, indexTwo);
            let indexThree = newContent.indexOf(">",indexTwo+1);

            content = content.substring(0, index + 9) + " :preview-src-list=\"['"+paramUrl+"']\" src=\"" + paramUrl + "\" "+newContent.substring(indexTwo + 1, indexThree)+"/>" + newContent.substring(indexThree+1, content.length);
            index = content.indexOf("<el-image", index + 68);
          }
          content = "<div>"+content+"</div>";
          let MyComponent = Vue.extend({
            template: content,
            data() {
              return {
              }
            }
          });
          let component = new MyComponent().$mount();
          document.getElementById('parent').appendChild(component.$el);
        }

      },
    },
    created() {
      this.downName = "";
      this.fileUrl = "";
      this.tittle = "";
      this.content = "";
      this.remark = "";
      this.isCollect = "";
      this.description = "";
      this.uploadList = [];
      this.screenHeight.height = this.mountHeight(310);
    },
    watch: {
      showSeeNotice:function(){
          this.model=this.showSeeNotice;
          if(this.showSeeNotice){
            this.initSearch(JSON.parse(this.notice));
          }else{
            this.downName = "";
            this.fileUrl = "";
            this.tittle = "";
            this.content = "";
            this.remark = "";
            this.isCollect = "";
            this.description = "";
            this.uploadList = [];
          }
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/userManagement/SeeNotice.vue